/* ========================================================================
 * BinaryCats: flyout.js v3.4.1
 * https://binarycats.dev/
 * ========================================================================
 * Copyright Binary Cats, Inc.
 * ======================================================================== */

;(function ($) {
    'use strict';

    // FLYOUT CLASS DEFINITION
    // =======================

    var Flyout = function (element, options) {
        this.options = $.extend({}, Flyout.DEFAULTS, options);
        this.$element = $(element);
        this.$overlay = this.options.$overlay || $('<div class="flyout__overlay"></div>').appendTo(document.body);
        this.isShown = false;

        if (this.options.remote) {
            this.$element.find('.flyout-body').load(this.options.remote);
        }
    };

    Flyout.VERSION = '3.4.1';

    Flyout.DEFAULTS = {
        backdrop: true,
        keyboard: true,
        show: true,
        position: 'right', // 'left' or 'right'
        size: 'md', // 'sm', 'md', 'lg', 'full'
    };

    Flyout.prototype.toggle = function (_relatedTarget) {
        return this.isShown ? this.hide() : this.show(_relatedTarget);
    };

    Flyout.prototype.show = function (_relatedTarget) {
        var that = this;
        var e = $.Event('show.bs.flyout', { relatedTarget: _relatedTarget });

        this.$element.trigger(e);

        if (this.isShown || e.isDefaultPrevented()) return;

        this.isShown = true;

        this.setupBackdrop();
        this.adjustSize();
        this.adjustPosition();

        this.$element.on('click.dismiss.bs.flyout', '[data-dismiss="flyout"]', $.proxy(this.hide, this));

        $(document).on('keydown.dismiss.bs.flyout', $.proxy(function (e) {
            if (e.which === 27) this.hide(); // Close on ESC
        }, this));

        this.$element
            .addClass('flyout-open')
            .attr('aria-hidden', false)
            .focus()
            .trigger('shown.bs.flyout', { relatedTarget: _relatedTarget });
    };

    Flyout.prototype.hide = function (e) {
        if (e) e.preventDefault();

        var that = this;
        var hideEvent = $.Event('hide.bs.flyout');

        this.$element.trigger(hideEvent);

        if (!this.isShown || hideEvent.isDefaultPrevented()) return;

        this.isShown = false;

        $(document).off('keydown.dismiss.bs.flyout');

        this.$element
            .removeClass('flyout-open')
            .attr('aria-hidden', true)
            .trigger('hidden.bs.flyout');

        this.removeBackdrop();
    };

    Flyout.prototype.setupBackdrop = function () {
        if (!this.options.backdrop) return;

        var that = this;

        this.$overlay
            .addClass('flyout-open')
            .appendTo(document.body)
            .off('click.dismiss.bs.flyout')
            .on('click.dismiss.bs.flyout', function () {
                if (that.options.backdrop === 'static') return;
                that.hide();
            });
    };

    Flyout.prototype.removeBackdrop = function () {
        if (!this.$overlay) return;
        this.$overlay.removeClass('flyout-open').detach();
    };

    Flyout.prototype.adjustSize = function () {
        this.$element
            .removeClass('flyout-sm flyout-md flyout-lg flyout-full')
            .addClass('flyout-' + this.options.size);
    };

    Flyout.prototype.adjustPosition = function () {
        this.$element
            .removeClass('flyout-left flyout-right')
            .addClass('flyout-' + this.options.position);
    };

    // FLYOUT PLUGIN DEFINITION
    // ========================

    function Plugin(option, _relatedTarget) {
        return this.each(function () {
            var $this = $(this);
            var data = $this.data('bs.flyout');
            var options = $.extend({}, Flyout.DEFAULTS, $this.data(), typeof option === 'object' && option);

            if (!data) $this.data('bs.flyout', (data = new Flyout(this, options)));
            if (typeof option === 'string') data[option](_relatedTarget);
            else if (options.show) data.show(_relatedTarget);
        });
    }

    var old = $.fn.flyout;

    $.fn.flyout = Plugin;
    $.fn.flyout.Constructor = Flyout;

    // FLYOUT NO CONFLICT
    // ==================

    $.fn.flyout.noConflict = function () {
        $.fn.flyout = old;
        return this;
    };

    // FLYOUT DATA-API
    // ===============

    $(document).on('click.bs.flyout.data-api', '[data-toggle="flyout"]', function (e) {
        var $this = $(this);
        var href = $this.attr('href');
        var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))); // Strip for IE7
        var option = $target.data('bs.flyout') ? 'toggle' : $.extend({}, $target.data(), $this.data());

        if ($this.is('a')) e.preventDefault();

        Plugin.call($target, option, this);
    });
})(jQuery);
